export default __webpack_public_path__ + "static/media/se-iPC.593b0cf1.jpg";